/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  activeHeader: "other",
  showPortalError: false,
  dpfilter: null,
  activeView: null,
  activeViewCon: null,
  validating: false,
  validated: true,
  validateResponse: null,
  validateError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_ACTIVE_HEADER: {
      return {
        ...state,
        activeHeader: action.payload,
      };
    }
    case types.SHOW_PORTAL_ERROR: {
      return {
        ...state,
        showPortalError: true,
      };
    }
    case types.HIDE_PORTAL_ERROR: {
      return {
        ...state,
        showPortalError: false,
      };
    }
    case types.SET_COLCON_FILTER_DP: {
      return {
        ...state,
        dpfilter: action.payload,
      };
    }
    case types.REMOVE_COLCON_FILTER_DP: {
      return {
        ...state,
        dpfilter: null,
      };
    }
    case types.SET_ACTIVE_VIEW_COL: {
      return {
        ...state,
        activeView: action.payload,
      };
    }
    case types.REMOVE_ACTIVE_VIEW_COL: {
      return {
        activeView: null,
      };
    }
    case types.SET_ACTIVE_VIEW_CON: {
      return {
        ...state,
        activeViewCon: action.payload,
      };
    }
    case types.REMOVE_ACTIVE_VIEW_CON: {
      return {
        activeViewCon: null,
      };
    }
    case types.VALIDATE_CONNECTOR: {
      return {
        ...state,
        validating: true,
        validated: false,
        validateError: null,
        validateResponse: null,
      };
    }
    case types.VALIDATE_CONNECTOR_SUCCESS: {
      return {
        ...state,
        validating: false,
        validated: true,
        validateResponse: action.payload,
      };
    }
    case types.VALIDATE_CONNECTOR_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        validating: false,
        validated: true,
        validateResponse: action.payload,
      };
    }
    case types.REMOVE_VALIDATE_CONNECTOR: {
      return {
        ...state,
        validating: false,
        validated: false,
        validateError: null,
        validateResponse: null,
      };
    }

    default:
      return state;
  }
}
